import styled from 'styled-components'

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '1280px',
  rowGap: '1rem',
  paddingBottom: 'calc(2vh + 24px)',
})
